class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
     
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    FacetFiltersForm.updateSortLabel();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        InitCustomFunctions();
      });
   // console.log(url);
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    InitCustomFunctions();
  }

 static renderProductGridContainer(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const newContainer =
    parsedHTML.getElementById('ProductGridContainer');

  const currentContainer =
    document.getElementById('ProductGridContainer');

  if (newContainer && currentContainer) {
    currentContainer.replaceWith(newContainer);
  }
}

static renderProductCount(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const newCount =
    parsedHTML.getElementById('ProductCount');

  const currentCount =
    document.getElementById('ProductCount');

  const currentDesktopCount =
    document.getElementById('ProductCountDesktop');

  if (newCount && currentCount) {
    currentCount.replaceWith(newCount);
    newCount.classList.remove('loading');
  }

  if (newCount && currentDesktopCount) {
    const desktopClone = newCount.cloneNode(true);

    desktopClone.id = 'ProductCountDesktop';

    currentDesktopCount.replaceWith(desktopClone);

    desktopClone.classList.remove('loading');
  }
}

  static renderFilters(html, event) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const facetDetailsElements =
    parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

  const matchesIndex = (element) => {
    const jsFilter = event
      ? event.target.closest('.js-filter')
      : undefined;

    return jsFilter
      ? element.dataset.index === jsFilter.dataset.index
      : false;
  };

  const facetsToRender = Array.from(facetDetailsElements).filter(
    (element) => !matchesIndex(element)
  );

  const countsToRender =
    Array.from(facetDetailsElements).find(matchesIndex);

  facetsToRender.forEach((element) => {
    const currentElement = document.querySelector(
      `.js-filter[data-index="${element.dataset.index}"]`
    );

    if (currentElement) {
      currentElement.replaceWith(element.cloneNode(true));
    }
  });

  FacetFiltersForm.renderActiveFacets(parsedHTML);
  FacetFiltersForm.renderAdditionalElements(parsedHTML);

  if (countsToRender) {
    FacetFiltersForm.renderCounts(
      countsToRender,
      event.target.closest('.js-filter')
    );
  }
}

static renderActiveFacets(html) {
  const activeFacetElementSelectors = [
    '.active-facets-mobile',
    '.active-facets-desktop'
  ];

  activeFacetElementSelectors.forEach((selector) => {
    const activeFacetsElement = html.querySelector(selector);

    if (!activeFacetsElement) return;

    const currentElement = document.querySelector(selector);

    if (currentElement) {
      currentElement.replaceChildren(
        ...activeFacetsElement.cloneNode(true).childNodes
      );
    }
  });

  FacetFiltersForm.toggleActiveFacets(false);
}

static renderAdditionalElements(html) {
  const mobileElementSelectors = [
    '.mobile-facets__open',
    '.mobile-facets__count',
    '.sorting'
  ];

  mobileElementSelectors.forEach((selector) => {
    const currentElement = document.querySelector(selector);
    const newElement = html.querySelector(selector);

    if (!currentElement || !newElement) return;

    currentElement.replaceChildren(
      ...newElement.cloneNode(true).childNodes
    );
  });

  document
    .getElementById('FacetFiltersFormMobile')
    .closest('menu-drawer')
    .bindEvents();

  document
    .querySelector('.mobile-facets__disclosure')
    .classList.add("test");

  FacetFiltersForm.updateSortLabel();
}

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');
    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    InitCustomFunctions();    
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
   if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }  
   
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    InitCustomFunctions();
  }

  static updateSortLabel() {
  const sortForm = document.getElementById('FacetSortForm');
  if (!sortForm) return;
  
  const selectedRadio = sortForm.querySelector('input[name="sort_by"]:checked');
  const summaryLabel = sortForm.querySelector('.facets__summary-label');
  
  if (selectedRadio && summaryLabel) {
    // Get the label text from the selected radio's parent
    const selectedLabel = selectedRadio.closest('.facet-checkbox')?.querySelector('.label')?.textContent;
    if (selectedLabel && summaryLabel.textContent !== selectedLabel) {
      summaryLabel.textContent = selectedLabel;
    }
  }
}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
 

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
     this.customRangeSlider();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    InitCustomFunctions();
     this.customRangeSlider();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  customRangeSlider() {
  var $scroll = $(".js-range-slider"),
        $priceStart = $(".field__input_min"),
        $priceEnd = $(".field__input_max"),
        initObj,
        priceMin =  parseFloat($scroll.data('min')),
        priceMax = parseFloat($scroll.data('max')),
        from = $priceStart.val() ? $priceStart.val() : 0,
        to = $priceEnd.val() ? $priceEnd.val() : priceMax,
        FacetXLarge = document.getElementById('FacetFiltersForm'),
        FacetXSmall = document.getElementById('FacetFiltersFormMobile');  
        $scroll.ionRangeSlider({
          skin: "round",
            type: "double",
            min: priceMin,
            max: priceMax,
            from: from,
            to: to,
            onChange: updateInputs,
            onFinish: updateInputs
        });
     initObj = $scroll.data("ionRangeSlider");
    function updateInputs (data) {
        from = data.from;
        to = data.to;
        $priceStart.val(from);
        $priceEnd.val(to);        
        $(window).resize(function() {
          var width = $(window).width();
          if (width > 750){
            FacetXLarge == null ? FacetXSmall.dispatchEvent(new Event("input")) : FacetXLarge.dispatchEvent(new Event("input"));
          }
          else{
            FacetXSmall.dispatchEvent(new Event("input"));
          }
        });
        $(window).width(function() {
          var width = $(window).width();
          if (width > 750){
            FacetXLarge == null ? FacetXSmall.dispatchEvent(new Event("input")) : FacetXLarge.dispatchEvent(new Event("input"));
          }
          else{
            FacetXSmall.dispatchEvent(new Event("input"));
          }
        });
        
    }
      $priceStart.on("change", function () {
        var val = $(this).prop("value");      
        if (val < priceMin) {
            val = priceMin;
        } else if (val > to) {
            val = to;
        }
        initObj.update({
            from: val
        });
        $(this).prop("value", val);
    });
    
    $priceEnd.on("change", function () {
        var val = $(this).prop("value");        
        if (val < from) {
            val = from;
        } else if (val > priceMax) {
            val = priceMax;
        }
        initObj.update({
            to: val
        });
        $(this).prop("value", val);
    });
  
}
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });     
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);   
  }
  
}

customElements.define('facet-remove', FacetRemove);




 class SidebarCarousel extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiper = new Swiper(this.querySelector("#swiper-sidebar-carousel"), {
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector("#swiper-sidebar-next"),
        prevEl: this.querySelector("#swiper-sidebar-prev"),
      },
    });
  }
}

customElements.define('sidebar-carousel', SidebarCarousel);


document.addEventListener('click', function (e) {
  if (
    e.target.closest('.facet-filters__sort') ||
    e.target.closest('.mobile-facets__open') ||
    e.target.closest('.mobile-facets')
  ) {
    setTimeout(function () {
      document.body.style.overflow = '';
      document.body.classList.remove('overflow-hidden');
    }, 1);
  }
});

(function() {
  function updateSortByLabel() {
    const sortForm = document.getElementById('FacetSortForm');
    if (!sortForm) return;
    
    const selectedRadio = sortForm.querySelector('input[name="sort_by"]:checked');
    const summarySpan = sortForm.querySelector('.facets__summary-label');
    
    if (selectedRadio && summarySpan) {
      const labelSpan = selectedRadio.closest('.facet-checkbox')?.querySelector('.label');
      const selectedText = labelSpan ? labelSpan.textContent : selectedRadio.getAttribute('data-value');
      
      if (selectedText && summarySpan.textContent !== selectedText) {
        summarySpan.textContent = selectedText;
      }
    } else if (summarySpan && summarySpan.textContent === '') {
      const defaultRadio = sortForm.querySelector('input[name="sort_by"]');
      if (defaultRadio) {
        const defaultLabel = defaultRadio.closest('.facet-checkbox')?.querySelector('.label')?.textContent;
        if (defaultLabel) summarySpan.textContent = defaultLabel;
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(updateSortByLabel, 100);
  });
  

  document.addEventListener('change', function(e) {
    if (e.target && e.target.name === 'sort_by') {
      setTimeout(updateSortByLabel, 50);
    }
  });
  
  if (window.Shopify && Shopify.designMode) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
          updateSortByLabel();
        } else if (mutation.type === 'childList') {
          const sortForm = document.getElementById('FacetSortForm');
          if (sortForm && mutation.target === sortForm || sortForm?.contains(mutation.target)) {
            updateSortByLabel();
          }
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked']
    });
    
    document.addEventListener('shopify:section:load', function() {
      setTimeout(updateSortByLabel, 100);
    });
    
    let lastValue = '';
    setInterval(function() {
      const sortForm = document.getElementById('FacetSortForm');
      if (sortForm) {
        const selectedRadio = sortForm.querySelector('input[name="sort_by"]:checked');
        const currentValue = selectedRadio?.value || '';
        if (currentValue !== lastValue) {
          lastValue = currentValue;
          updateSortByLabel();
        }
      }
    }, 500);
  }
})();